import React, { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';

import Description from '../../Description';
import Tooltip from '../../../Tooltip/Tooltip';
import { normalizeRichTextValue } from '../utils';
import productInfoStyles from '../../styles.module.scss';

const DISABLED_CONFIG = { readonly: true };

const RichTextField = ({
  data, value, disabled, isDiff, onChange, className,
}) => {
  const handleChange = useCallback((html) => onChange(html, data, () => {}), [data, onChange]);

  const titleNode = useMemo(() => (
    isDiff
      ? (
        <Tooltip content="Unpublished changes" placement="top">
          <span className={productInfoStyles.diffDot}>{data.title}</span>
        </Tooltip>
      )
      : data.title
  ), [data.title, isDiff]);

  return (
    <div className={className}>
      <Description
        title={titleNode}
        currentValue={normalizeRichTextValue(value)}
        additionalConfig={disabled ? DISABLED_CONFIG : undefined}
        onChange={handleChange}
      />
    </div>
  );
};

RichTextField.propTypes = {
  data: PropTypes.shape({ title: PropTypes.string }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  disabled: PropTypes.bool,
  isDiff: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

RichTextField.defaultProps = {
  value: '',
  disabled: false,
  isDiff: false,
  className: undefined,
};

export default RichTextField;
